
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  private jibing: any = ["治愈", "好转", "稳定", "恶化", "不清楚"];
  private get c() {
    const arr = this.data;
    if (!arr.value || arr.value.length === 0) {
      const obj = {
        入院诊断: "",
        加重原因: "",
        住院天数: "",
        疾病转归: "",
      };
      arr.value = [obj];
    }
    this.$forceUpdate();
    return arr;
  }
  private radioClick(ev: any, index: any) {
    if (!this.ifCompose) {
      return;
    }
    this.c.value[index]["疾病转归"] === ev
      ? (this.c.value[index]["疾病转归"] = "")
      : (this.c.value[index]["疾病转归"] = ev);
    this.$emit("update", this.c);
  }
  private addOne() {
    const obj = {
      入院诊断: "",
      加重原因: "",
      住院天数: "",
      疾病转归: "",
    };
    this.c.value.push(obj);
  }
  private delOne(index: any) {
    this.c.value.splice(index, 1);
  }
}
